import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

const EditorialIntegrationBanner: React.FC = () => {
  const { theme } = useTheme();
  
  const logos = [
    { name: 'LinkedIn', logo: '/logos/linkedin.svg' },
    { name: 'TikTok', logo: '/logos/tiktok.svg' },
    { name: 'Meta', logo: '/logos/meta.svg' },
    { name: 'Google', logo: '/logos/google.svg' },
    { name: 'Stripe', logo: '/logos/stripe.svg' },
    { name: 'Shopify', logo: '/logos/shopify.svg' },
    { name: 'Slack', logo: '/logos/slack.svg' },
    { name: 'Notion', logo: '/logos/notion.svg' },
    { name: 'Zapier', logo: '/logos/zapier.svg' },
    { name: 'Instagram', logo: '/logos/instagram.svg' },
  ];

  const bgColor = theme === 'dark' ? '#111111' : '#f4f2f1';
  const lineColor = theme === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';
  const horizontalLineGradient = `linear-gradient(to right, transparent, ${lineColor} 5%, ${lineColor} 95%, transparent)`;

  return (
    <section 
      className="relative mt-24 sm:mt-0 w-screen -ml-[calc((100vw-100%)/2)] transition-colors duration-300" 
      style={{ backgroundColor: bgColor }}
    >
      {/* Top horizontal line at bottom-[38px] - faded edges */}
      <div 
        className="absolute bottom-[60px] left-0 right-0 h-px pointer-events-none z-0"
        style={{ background: horizontalLineGradient }}
      />
      {/* Bottom horizontal line at bottom-0 - solid */}
      <div 
        className="absolute bottom-0 left-0 right-0 h-px pointer-events-none z-0"
        style={{ backgroundColor: lineColor }}
      />
      
      {/* 38px band for logos - centered between the two grid lines */}
      <div className="relative h-[60px] flex items-center w-full">
        {/* Left fade gradient */}
        <div 
          className="absolute left-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
          style={{ background: `linear-gradient(to right, ${bgColor}, transparent)` }}
        />
        {/* Right fade gradient */}
        <div 
          className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
          style={{ background: `linear-gradient(to left, ${bgColor}, transparent)` }}
        />
        
        <div className="overflow-hidden w-full">
          {/* Scrolling logos */}
          <div className="flex animate-[scroll_30s_linear_infinite] gap-20 px-8">
            {[...logos, ...logos, ...logos].map((logo, index) => (
              <div
                key={index}
                className="flex items-center shrink-0"
              >
                <img
                  src={logo.logo}
                  alt={logo.name}
                  width={24}
                  height={24}
                  className="h-6 w-auto object-contain transition-all duration-300"
                  style={{ 
                    filter: theme === 'dark' 
                      ? 'grayscale(100%) brightness(0) invert(1)' 
                      : 'grayscale(100%)',
                    opacity: theme === 'dark' ? 0.7 : 0.5
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorialIntegrationBanner;
